import React from 'react';

import OrdersList from '@/modules/packhouse/printingOrders/components/SupervisorsListing/SupervisorOrderRow/OrdersList';
import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
/* eslint-disable no-console */
import Collapse from '@/shared/components/atoms/Collapse';

interface Props {
  ordersData: IPrintingOrders.ISupplierOrdersItem;
  date: string;
}

const SupervisorOrderRow: React.FC<Props> = ({ date, ordersData }) => {
  return (
    <>
      <Collapse
        header={<div>{ordersData?.user?.userName}</div>}
        containerClassName=''
        childrenPadding='px-0 py-16'
        bgColor='bg-primary-100'
        containerPadding='py-8 px-16'
        itemClassName='text-primary-default'
      >
        <OrdersList date={date} ordersData={ordersData} />
      </Collapse>
    </>
  );
};
export default SupervisorOrderRow;
